import { getDocument } from './general';

const getCookie = (name = '', cookieStr = '') => {
  const nameEQ = `${name}=`;
  const cookies = cookieStr.split(';');
  for (let i = 0; i < cookies.length; i += 1) {
    let cookie = cookies[i];
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1, cookie.length);
    }
    if (cookie.indexOf(nameEQ) === 0) {
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  return '';
};

/**
 * Reads the SAS cookie and decodes it
 */
const decodeSASCookie = () => {
  let sasCookieVal: string | undefined = getCookie('THD_SAS');
  if (sasCookieVal) {
    sasCookieVal = sasCookieVal.replace(/"/g, '');
    return JSON.parse(atob(sasCookieVal));
  }
  return null;
};

/**
 * Getting the device ID from SAS
 */
export const getDeviceIdFromSAS = (): string | null => {
  const sasCookieVal = decodeSASCookie();
  if (sasCookieVal) {
    return sasCookieVal.deviceId;
  }
  return null;
};

/**
 * Getting the IAM token from SAS
 */
export const getNinetyDayTokenFromSAS = (): string | null => {
  const sasCookieVal = decodeSASCookie();
  if (sasCookieVal) {
    return sasCookieVal.ninetyDayToken;
  }
  return null;
};

/**
 * Checks if a cookie exists with the specified key.
 *
 * @param {string} key - The name of the cookie to check.
 * @returns {boolean} Value of cookie, otherwise undefined if cookie does not exist
 */
export const getCookieValue = (key: string) => {
  if (!key) return undefined;
  const cookies = getDocument()?.cookie.split(';');

  // Use the find method to check if any cookie starts with the given name
  const cookie = cookies?.find((cookieVal) => {
    const trimmedCookie = cookieVal.trim();
    return trimmedCookie.startsWith(`${key}=`);
  });

  if (cookie) {
    // Extract the value after the '=' character
    const value = cookie?.split('=')?.[1];
    return value.trim();
  }

  return undefined;
};

/**
 * Checks if a cookie exists with the specified key.
 *
 * @param {string} key - The name of the cookie to check.
 * @returns {string | undefined} Value of cookie, otherwise undefined if cookie does not exist
 */
export const isCookieEnabled = (key: string) => {
  const validTrueInput = new Set(['true', '1']);
  const validFalseInput = new Set(['false', '0']);
  try {
    const cookieValue = getCookieValue(key);
    if (cookieValue === undefined) return false;
    if (validTrueInput.has(cookieValue)) return true;
    if (validFalseInput.has(cookieValue)) return false;
  } catch (err) {
    return false;
  }
  return false;
};
